// import { PROGRAMMING_CONTENT_PATH_REGEX } from "app/utils/constants/regexConstants";
// import { ROUTES, BASE_PATHS } from "app/utils/constants/routeConstants";
import { USER_ROLES } from "app/utils/constants/constants";

// Define allowed roles for Run and Submit access
const ALLOWED_ROLES = [USER_ROLES.ROLE_ADMIN, USER_ROLES.ROLE_PREMIUM_USER];

export const isAllowedToAccess = (user, allowedRoles) => {
  const userRoles = user?.authorities || []; // Use authorities instead of roles
  if (userRoles && allowedRoles) {
    return allowedRoles.some((role) => userRoles.includes(role));
  }
  return false;
};

export const isSideBarAllowed = (path, userRoles) => {
  // Check if the user has the ROLE_ADMIN role
  const isAdmin = userRoles && userRoles.includes(USER_ROLES.ROLE_ADMIN);

  // If the user is an admin, always show the sidebar
  if (isAdmin) {
    return true;
  }

  // // Check if the user is not logged in (empty or null userRoles)
  // const isNotLoggedIn = !userRoles || userRoles.length === 0;

  // // Check if the path is /algos-and-ds or a subpath
  // const isAlgosAndDs = path.startsWith(BASE_PATHS.ALGOS_AND_DS);

  // // For non-logged-in users, allow sidebar on /algos-and-ds and subpaths
  // if (isNotLoggedIn && isAlgosAndDs) {
  //   return true;
  // }

  // // For non-admin users, check other allowed paths
  // const isProgrammingContentPage = path.match(PROGRAMMING_CONTENT_PATH_REGEX);

  // // Check if the path matches defined routes
  // const isLogin = path === ROUTES.USER_LOGIN;
  // const isSignup = path === ROUTES.USER_SIGNUP;
  // const isForgotPassword = path === ROUTES.USER_FORGOT_PASSWORD;
  // // const isDashboard = path === ROUTES.HOME;
  // // const isUpgrade = path === ROUTES.UPGRADE;

  // // Return true if any of the conditions are met
  // return isProgrammingContentPage || isLogin || isSignup || isForgotPassword;
};

export const canAccessRunAndSubmit = (user, options = {}) => {
  const { extraAllowedRoles = [], requireLogin = true } = options;

  // Combine default and extra allowed roles
  const allAllowedRoles = [...ALLOWED_ROLES, ...extraAllowedRoles];

  // If login is required, check if user is logged in
  const isLoggedIn = !!user;
  if (requireLogin && !isLoggedIn) {
    return false;
  }

  // Check if user has any allowed role using isAllowedToAccess
  return isAllowedToAccess(user, allAllowedRoles);
};
